import React from 'react';
import Bar from '../components/Bar';
import Home from '../components/Home';
import Services from '../components/Services';
import Skills from '../components/Skills';
import Description from '../components/Description';
import Plan from '../components/Plan';
import Team from '../components/Team';
import Footer from '../components/Footer';
// import Client from '../components/Clients';


// import {
//   useParams
// } from 'react-router';


const Main = () => {

  // let { language } = useParams();
  // console.log(language);
  return (
    <>
      <Bar/>
      <main>
        <Home/>
        <Services/>
        <Skills/>
        <Description/>
         <Plan/>
        {/*<Client/>*/}
        <Team/>
        <Footer/>
        
      </main>

    </>
  )
};

export default Main;
